require('./expensesByCategoryInfo.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classNames = require('classnames');

// @commons
const ExpensesByCategoryComparativeBars = require('components/expenses/expensesByCategoryComparativeBars/expensesByCategoryComparativeBars');

// @constants
const { getCategoryIcon } = require('constants/categories');

// @ utils
const { formatText } = require('core/i18n').i18n;

class ExpensesByCategoryInfo extends React.Component {
    render() {
        const { category, totalExpenses, totalExpensesByCategory} = this.props;
        const iconClasses = classNames('expenses-by-category-info__icon',
            getCategoryIcon(category)
        );
        const values = [totalExpenses || 0, totalExpensesByCategory || 0];
        const colors = ['#fcb900', '#afbdc4'];

        return (
            <div className="col-xs-12">
                <div className="container-fluid">
                    <div className="row expenses-by-category-info__content">
                        <div className="col-xs-12 col-md-8">
                            <span className="expenses-by-category-info__content__title">
                                <i className={iconClasses} />
                                <div className="expenses-by-category-info__content__text">
                                    {formatText('categories-'+category)}
                                </div>
                            </span>
                        </div>
                        <div className="col-xs-12 col-md-4 expenses-by-category-info__buttons">
                            <ExpensesByCategoryComparativeBars
                                values={values}
                                colors={colors}
                                />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ExpensesByCategoryInfo.propTypes = {
    category: PropTypes.string,
    totalExpenses: PropTypes.number,
    totalExpensesByCategory: PropTypes.number
};

module.exports = ExpensesByCategoryInfo;

